import React, { useState, useEffect } from "react";
import useEffectSkipFirst from "../../../components/utils/useEffectSkipFirst";
import SportFilter from "./SportFilter";
import DateFilter from "./DateFilter";
import SearchFilter from "./SearchFilter";
// import { useSelector } from "react-redux";
// import { motion } from "framer-motion";
import styles from "./Filters.module.css";
export default function Filters({ setFilters }) {
	const [searchString, setSearchString] = useState("");

	const [filtersChanged, setFiltersChanged] = useState(false);

	const [sportFilters, setSportFilters] = useState({
		baseball: false,
		football: false,
		soccer: false,
		softball: false,
		basketball: false,
	});
	const [dateFilters, setDateFilters] = useState({
		startDate: null,
		endDate: null,
	});

	// useEffectSkipFirst(() => {

	// }, [sportFilters,dateFilters,searchString])

	const getDateFilters = (dates) => {
		let endDate = "";
		let startDate = "";

		if (
			dateFilters.endDate instanceof Date &&
			!isNaN(dateFilters.endDate.valueOf())
		) {
			endDate = dateFilters.endDate.toISOString();
		}
		if (
			dateFilters.startDate instanceof Date &&
			!isNaN(dateFilters.startDate.valueOf())
		) {
			startDate = dateFilters.startDate.toISOString();
		}
		return { startDate: startDate, endDate: endDate };
	};
	const getSportFilters = () => {
		let sportsArray = [];
		for (const key in sportFilters) {
			if (sportFilters[key]) {
				switch (key) {
					case "baseball":
						sportsArray.push("baseball");
						break;
					case "football":
						sportsArray.push("football");
						break;
					case "soccer":
						sportsArray.push("soccer");
						break;
					case "softball":
						sportsArray.push("softball");
						break;
					case "basketball":
						sportsArray.push("basketball");
						break;
					default:
				}
			}
		}
		return sportsArray;
	};

	const sendIt = () => {
		let parsedDates = getDateFilters();
		let parsedSports = getSportFilters();

		setFilters({
			dates: parsedDates,
			sports: parsedSports,
			searchQuery: searchString,
		});
	};

	return (
		<form className={styles.filterBar}>
			<SearchFilter
				refinedSearch={searchString}
				onChange={(search) => setSearchString(search)}
			/>
			<DateFilter
				onChange={(dates) => setDateFilters(dates)}
				dates={dateFilters}
			/>

			<SportFilter
				selected={sportFilters}
				onChange={(sports) => setSportFilters(sports)}
			/>

			<button
				type="button"
				onClick={(e) => sendIt(e)}
				className={styles.applyBtn}
			>
				APPLY
			</button>
		</form>
	);
}
